export const GET_NEW_PARTNERS_REQUEST = 'instalent/GET_NEW_PARTNERS_REQUEST';
export const GET_NEW_PARTNERS_SUCCESS = 'instalent/GET_NEW_PARTNERS_SUCCESS';
export const GET_NEW_PARTNERS_FAIL = 'instalent/GET_NEW_PARTNERS_FAIL';
